import React, { useEffect, useMemo, useState, useRef } from "react";
// import {
//     DataGrid,
//     GridColDef,
//     GridSelectionModel,
//     GridRowId,
// } from "@mui/x-data-grid";
import { DataGridPro, GridColDef, GridInputSelectionModel, GridRowId, GridRowModesModel, GridSelectionModel, GridSortModel, GridFilterModel} from "@mui/x-data-grid-pro";

import { RiExpandUpDownLine } from "react-icons/ri";
import {
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormHelperText,
    Grid,
    IconButton,
    LinearProgress,
    Link,
    SelectChangeEvent,
    Typography,
    debounce,
    Tooltip
} from "@mui/material";
import moment from "moment";
import useAuth from "../../context/AuthProvider";

import { DiligentSearchDocument, TaxTransactionReportModel_Resp, TaxTransactionReportModel } from "../../models/TaxTransactionReportModel";
import { AddEditDiligentSearh } from "../AddEdit/AddEditDiligentSearch";
import { Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
//import { GenericStyledDropZone } from "../AddEdit/AddEditResubmitSingleDocument";
import { useDropzone } from "react-dropzone";
import { config } from '../../Constants';
import Swal from "sweetalert2";
import { minHeight } from "@mui/system";
import { apiClient } from "../../helper/api";
import { getRowsPerPageOptions } from "../AddEdit/CustomFunctions";
import { columnWidth } from "./constants";
import { getGridStringOperators } from '@mui/x-data-grid-pro';
import { FileDownload, KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { CloudUpload } from '@mui/icons-material';
import { EditOutlined } from "@mui/icons-material";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import FilePresentOutlinedIcon from '@mui/icons-material/FilePresentOutlined';
import { Box, Button, Menu, MenuItem, Paper } from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import { ReportModule } from "../../Pages/ReportModule";
import { writeXlsxFile } from "../../helper/utils";
import { formatUtcToLocal } from "../../helper/utils";

var formData = new FormData();

export enum DiligentTabs {
    OpenDiligent = 1,
    CompletedDiligent = 2,
}

interface FilterItem {
    columnField: string;
    value: any; // Adjust 'any' to the actual type if known
  }

export interface FMFilters {
   items: FilterItem[];
}

interface Iprops {
    ReportModuleCL: TaxTransactionReportModel_Resp;
    fetchDataMain: (
        pageSize: number,
        currentPage: number,
        tabValue: DiligentTabs,
        newFilters?: GridFilterModel,
        newSort?: GridSortModel
    ) => Promise<void>;
    tabValue: DiligentTabs,
    selectedRows: TaxTransactionReportModel[] | undefined
    setSelectedRows: React.Dispatch<React.SetStateAction<TaxTransactionReportModel[] | undefined>>
    _currentPage: number
    setCurrentPage:  React.Dispatch<React.SetStateAction<number>>
    _pageSize: number
    setPageSize:  React.Dispatch<React.SetStateAction<number>>
    sortRef: React.MutableRefObject<GridSortModel>
    filterRef: React.MutableRefObject<GridFilterModel | undefined>
}

export const DiligentSearchList: React.FC<Iprops> = ({
    ReportModuleCL,
    fetchDataMain,
    tabValue,
    selectedRows,
    setSelectedRows,
    setCurrentPage,
    setPageSize,
    _currentPage,
    _pageSize,
    sortRef,
    filterRef,
}) => {
    const completedPage = tabValue === DiligentTabs.CompletedDiligent
    const [loading, setLoading] = useState(false);
    const { user } = useAuth();
    const token = user?.token;

    const fetchItem = (customerPolicyId: number) => {

        apiClient(`/DiligentSearch/getDiligentSearchDocument?customerPolicyId=${customerPolicyId}`,
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            })
            .then((res) => {
                if (!res) return
                
                // Do something with the response
                setDiligentDocument(res.data);
            })
    }

    const initialLBData: TaxTransactionReportModel_Resp = {
        getOutstandingFilingsReport_Respdata: [
            {
                needDiligentSearch: "",
                diligentSearchCompleted: ""
            }
        ],
        totalCount: 0,
        needDiligentSearch: undefined,
        diligentSearchCompleted: undefined,
        dateCompleted: undefined
    };

    const [Open, setOpen] = React.useState(false);
    const [openDoc, setOpenDoc] = React.useState(false);
    const [showDoc, setShowDoc] = React.useState(false);
    const [ID, setID] = React.useState();
    const [Formdata, setFormData] = React.useState(initialLBData);
    const [DiligentDocument, setDiligentDocument] = React.useState<DiligentSearchDocument[]>();

    // Action options
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const openMenuItem = Boolean(anchorEl);

    const handleClickOpenActionOptions = (reportTagId: number) => {
        const buttonEl = document.getElementById(`action-options-button-${reportTagId}`) as HTMLElement | null;
        setAnchorEl((prev) => (prev?.id === `action-options-button-${reportTagId}` ? null : buttonEl));
    };
    const handleCloseActionOptions = () => {
        setAnchorEl(null);
    };

    const handleClose = () => {

        setOpen(false);
        setOpenDoc(false);
        setShowDoc(false)
        // fetchData();
    };
    const handleDocClose = () => {

        setOpen(false);
        setOpenDoc(false);
        setShowDoc(false)
        // fetchData();
    };
    function OpneShowDocument(id: any) {

        setID(id);
        setShowDoc(true);
        fetchItem(id);
    }
    const handleSubmit = () => {
        fetchDataMain(_pageSize, _currentPage, tabValue);
        setOpen(false);
    };

    const handleEdit = (ILobData: TaxTransactionReportModel_Resp) => {

        setFormData(ILobData);
        setOpen(true);

    };

    function UploadDocument(id: any) {
        setID(id);
        setOpenDoc(true);
    }

    const columns: GridColDef[] = tabValue === DiligentTabs.OpenDiligent ? [
        {
            field: 'stateRuleMatrixId',
            minWidth: columnWidth['actions'],
            headerName: "Edit",
            hideSortIcons: true,
            filterable: false, 
            sortable: false,
            disableColumnMenu: true,
            disableExport: true,
            renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), align: 'center', headerAlign: 'center',
            renderCell: (params) => (<>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.0, justifyContent: 'flex-start' }}>
                    <Button
                        id={`action-options-button-${params.row.customerPolicyId}`}
                        aria-controls={anchorEl?.id === `action-options-button-${params.row.customerPolicyId}` ? `action-options-menu-${params.row.customerPolicyId}` : undefined}
                        aria-haspopup="true"
                        aria-expanded={anchorEl?.id === `action-options-button-${params.row.customerPolicyId}` ? 'true' : undefined}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleClickOpenActionOptions(params.row.customerPolicyId);
                        }}
                    >
                        <MoreVertOutlinedIcon fontSize="small" />
                    </Button>
                    <Menu
                        id={`action-options-menu-${params.row.customerPolicyId}`}
                        aria-labelledby={`action-options-button-${params.row.customerPolicyId}`}
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl && anchorEl.id === `action-options-button-${params.row.customerPolicyId}`)}
                        onClose={handleCloseActionOptions}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        MenuListProps={{
                            'aria-labelledby': `action-options-button-${params.row.customerPolicyId}`,
                          }}
                        sx={{
                            '& .MuiMenuItem-root': {
                                fontSize: '14px',
                                padding: '8px 16px',
                            },
                        }}
                    >
                        
                        <MenuItem onClick={(e) => { handleCloseActionOptions(); e.stopPropagation(); handleEdit(params.row); }}>
                        
                        <EditOutlined fontSize="small" color="action" style={{ marginRight: 8 }} /> Edit
                        </MenuItem>
                        <MenuItem onClick={(e) => { handleCloseActionOptions(); e.stopPropagation(); OpneShowDocument(params.row.customerPolicyId); }}>
                        <FilePresentOutlinedIcon fontSize="small" color="action" style={{ marginRight: 8 }} /> View documents attached</MenuItem>
                        <MenuItem onClick={(e) => { handleCloseActionOptions(); e.stopPropagation(); UploadDocument(params.row.customerPolicyId); }}>
                        <FileUploadOutlinedIcon fontSize="small" color="action" style={{ marginRight: 8 }} /> Upload</MenuItem>
                        
                    </Menu>
                </Box>
            </>)
        },
        {
            field: "homeState", headerName: "HomeState", type: "string", headerAlign: "left", hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortRef.current?.find(
                    (item: any) => item.field === 'homeState'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, align: "left",
            minWidth: columnWidth['homeState'],
        },

        {
            field: "insuredName", headerName: "InsuredName", type: "string", headerAlign: "left", hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortRef.current?.find(
                    (item: any) => item.field === 'insuredName'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, align: "left",
            minWidth: columnWidth['insuredName'],
        },

        {
            field: "policyNumber", headerName: "PolicyNumber", type: "string", headerAlign: "left", hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortRef.current?.find(
                    (item: any) => item.field === 'policyNumber'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, align: "left",
            minWidth: columnWidth['policyNumber'],
        },
        {
            field: "invoiceNumber", headerName: "InvoiceNumber", type: "string", headerAlign: "left", hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortRef.current?.find(
                    (item: any) => item.field === 'invoiceNumber'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, align: "left",
            minWidth: columnWidth['invoiceNumber'],
        },

        {
            field: "needDiligentSearch", headerName: "NeedDiligentSearch", type: "string", headerAlign: "left", hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortRef.current?.find(
                    (item: any) => item.field === 'needDiligentSearch'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, align: "left",
            minWidth: columnWidth['needDiligentSearch'],
        },
        {
            field: "diligentSearchNotes", headerName: "DiligentSearchNotes", type: "string", headerAlign: "left", hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortRef.current?.find(
                    (item: any) => item.field === 'diligentSearchNotes'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, align: "left",
            minWidth: columnWidth['diligentSearchNotes'],
        },
          
        {
            field: "suspended", headerName: "Suspended", type: "string", headerAlign: "left", hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortRef.current?.find(
                    (item: any) => item.field === 'suspended'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, align: "left",
            minWidth: columnWidth['suspended'],
        },

        {
            field: "transactionType", headerName: "TransactionType", type: "string", headerAlign: "left", hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortRef.current?.find(
                    (item: any) => item.field === 'transactionType'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, align: "left",
            minWidth: columnWidth['transactionType'],
        },

        {
            field: "carrier", headerName: "Carrier", type: "string", headerAlign: "left", hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortRef.current?.find(
                    (item: any) => item.field === 'carrier'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, align: "left",
            minWidth: columnWidth['carrier'],
        },


        {
            field: "naic", headerName: "NAIC", type: "string", headerAlign: "left", hideSortIcons: true, renderHeader: (params) => {
                const sortItem = sortRef.current?.find(
                    (item: any) => item.field === 'naic'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, align: "left",
            minWidth: columnWidth['naic'],
        },
        {
            field: "invDate", headerName: "InvoiceDate", type: "string", headerAlign: "left", hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortRef.current?.find(
                    (item: any) => item.field === 'invDate'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, align: "left",
            minWidth: columnWidth['invDate'],
        },
        {
            field: "policyEffDate", headerName: "PolicyEffDate", type: "string", headerAlign: "left", hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortRef.current?.find(
                    (item: any) => item.field === 'policyEffDate'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, align: "left",
            minWidth: columnWidth['policyEffDate'],
        },


        {
            field: "policyExpDate", headerName: "PolicyExpDate", type: "string", headerAlign: "left", hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortRef.current?.find(
                    (item: any) => item.field === 'policyExpDate'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, align: "left",
            minWidth: columnWidth['policyExpDate'],
        },

        {
            field: "grossPremium", headerName: "Gross Premium", type: "string", headerAlign: "right", hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortRef.current?.find(
                    (item: any) => item.field === 'grossPremium'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, align: "right",
            renderCell: (params) => {
                return (
                    <div>
                        { params.value? `$`+(params.value) : ""}
                    </div>
                )
            },
            minWidth: columnWidth['grossPremium'],
        },
        {
            field: "client", headerName: "Client", type: "string", headerAlign: "left", hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortRef.current?.find(
                    (item: any) => item.field === 'client'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, align: "left",
            minWidth: columnWidth['client'],
        },
    ] : tabValue === DiligentTabs.CompletedDiligent ? [
        {
            field: 'stateRuleMatrixId',
            minWidth: columnWidth['actions'],
            headerName: "Edit", hideSortIcons: true,
            disableColumnMenu: true,
            filterable: false,
            sortable: false,
            align: 'center', headerAlign: 'center', renderCell: (params) => (<div>
                <IconButton
                    color="primary"
                    onClick={() => { OpneShowDocument(params.row.customerPolicyId) }}
                    sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(32,153,210,0.15) !important' } }}
                >
                    <Tooltip
                        title="Edit"
                        placement="top"
                        arrow
                    >
                    <EditOutlinedIcon fontSize="small" color="primary" />
                    </Tooltip>
                </IconButton>
            </div>)
        },
        {
            field: "homeState", headerName: "HomeState", type: "string", headerAlign: "left", hideSortIcons: true, renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), align: "left",
            minWidth: columnWidth['homeState'],
        },

        {
            field: "insuredName", headerName: "InsuredName", type: "string", headerAlign: "left", hideSortIcons: true, renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), align: "left",
            minWidth: columnWidth['insuredName'],
        },

        {
            field: "policyNumber", headerName: "PolicyNumber", type: "string", headerAlign: "left", hideSortIcons: true, renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), align: "left",
            minWidth: columnWidth['policyNumber'],
        },
        {
            field: "invoiceNumber", headerName: "InvoiceNumber", type: "string", headerAlign: "left", hideSortIcons: true, renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), align: "left",
            minWidth: columnWidth['invoiceNumber'],
        },

        {
            field: "needDiligentSearch", headerName: "NeedDiligentSearch", type: "string", headerAlign: "left", hideSortIcons: true, renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), align: "left",
            minWidth: columnWidth['needDiligentSearch'],
        },
        {
            field: "diligentSearchNotes", headerName: "DiligentSearchNotes", type: "string", headerAlign: "left", hideSortIcons: true, renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), align: "left",
            minWidth: columnWidth['diligentSearchNotes'],
        },
        {
            field: "diligentSearchCompleted", headerName: "DiligentSearchCompleted", type: "string", headerAlign: "left", hideSortIcons: true, renderHeader: (params) => (
                
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), align: "left",
            minWidth: columnWidth['diligentSearchCompleted'],
        },
        {
            field: "dateCompleted", headerName: "DateCompleted", type: "string", headerAlign: "left", hideSortIcons: true, renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ),
            renderCell: (params) =>
                (
                  <div>
                    {(params.row.dateCompleted != null && params.row.dateCompleted != '') ? formatUtcToLocal(params.row.dateCompleted, "MM/DD/YYYY", true) : ""}
                  </div>
                ), align: "left",
           // minWidth: columnWidth['dateCompleted'],
        },         
        {
            field: "suspended", headerName: "Suspended", type: "string", headerAlign: "left", hideSortIcons: true, renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), align: "left",
            minWidth: columnWidth['suspended'],
        },

        {
            field: "transactionType", headerName: "TransactionType", type: "string", headerAlign: "left", hideSortIcons: true, renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), align: "left",
            minWidth: columnWidth['transactionType'],
        },

        {
            field: "carrier", headerName: "Carrier", type: "string", headerAlign: "left", hideSortIcons: true, renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), align: "left",
            minWidth: columnWidth['carrier'],
        },


        {
            field: "naic", headerName: "NAIC", type: "string", headerAlign: "left", hideSortIcons: true, renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), align: "left",
            minWidth: columnWidth['naic'],
        },
        {
            field: "invDate", headerName: "InvoiceDate", type: "string", headerAlign: "left", hideSortIcons: true, renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), align: "left",
            minWidth: columnWidth['invDate'],
        },
        {
            field: "policyEffDate", headerName: "PolicyEffDate", type: "string", headerAlign: "left", hideSortIcons: true, renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), align: "left",
            minWidth: columnWidth['policyEffDate'],
        },


        {
            field: "policyExpDate", headerName: "PolicyExpDate", type: "string", headerAlign: "left", hideSortIcons: true, renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), align: "left",
            minWidth: columnWidth['policyExpDate'],
        },

        {
            field: "grossPremium", headerName: "GrossPremium", type: "string", headerAlign: "left", hideSortIcons: true, renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), align: "left",
            minWidth: columnWidth['grossPremium'],
        },
        {
            field: "client", headerName: "Client", type: "string", headerAlign: "left", hideSortIcons: true, renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), align: "left",
            minWidth: columnWidth['client'],
        },
        

    ]: [];
    const updatedColumns = columns.map(column => {
        if (column.type === 'string') {
            return {
                ...column,
                filterOperators: getGridStringOperators().filter(operator => operator.value === 'contains'),
            };
        }
        return column;
    });
    const onRowsSelectionHandler = (ids: GridSelectionModel) => {
      const selectedIDs = new Set(ids)
      const selectedRowData = ReportModuleCL.getOutstandingFilingsReport_Respdata.filter(
        (row) => selectedIDs.has(row?.rowNum ?? "")
      )
      setSelectedRows(selectedRowData)
    }

    const debouncedFetch = React.useCallback(() => {
        console.log('==debouncedFetch==')
        debouncedOnFilterChange();
    }, [tabValue, _currentPage, _pageSize, filterRef.current, sortRef.current]);

    const debouncedOnFilterChange = debounce(() => {
        console.log('==debouncedOnFilterChange==')
        fetchDataMain(_pageSize, _currentPage, tabValue, filterRef.current, sortRef.current)
    }, 1200);

    const handleSortModelChange = React.useCallback((sortModel: GridSortModel) => {
        sortRef.current = sortModel
        console.log('==handleSortModelChange==')
        fetchDataMain(_pageSize, _currentPage, tabValue, filterRef.current, sortRef.current)
    }, [completedPage]);

    const handleFilterChange = React.useCallback((gridFilter: GridFilterModel) => {
        filterRef.current = gridFilter
        console.log('==handleFilterChange==')
        debouncedFetch()
    }, [completedPage]);

    const handleNextPreviousPage = (newPage: number) => {
        setCurrentPage(newPage);
        fetchDataMain(_pageSize, newPage, tabValue, filterRef.current, sortRef.current)
    };

    const handlePageSize = (newPageSize: number) => {
        setPageSize(newPageSize);
        fetchDataMain(newPageSize, _currentPage, tabValue, filterRef.current, sortRef.current)
    };

    const keyNames: (keyof TaxTransactionReportModel)[] = [
        'homeState', 'insuredName', 'policyNumber', 'invoiceNumber',
        'transactionType', 'carrier', 'naic', 'invDate', 'policyEffDate', 'policyExpDate', 
        'grossPremium', 'client', 'diligentSearchToGmac', 'suspended', 'needDiligentSearch', 'diligentSearchNotes',
        'diligentSearchCompleted', 'dateCompleted'
    ]

    const onExportXlsx = (values: TaxTransactionReportModel[]) => {
        setLoading(true);
        if (values.length === 0) {
            return
        }
        let filteredKeyNames = keyNames;
        if (tabValue === DiligentTabs.OpenDiligent) {
            filteredKeyNames = keyNames.filter(key => key !== 'dateCompleted' && key !== 'diligentSearchCompleted');
        }
        const items = values.map(item => {
            const update: (string | number | Date | undefined)[] = [];
    
            filteredKeyNames.map((key: keyof TaxTransactionReportModel) => {
                if (key === 'dateCompleted') {
                    update.push(formatUtcToLocal(item[key], "MM/DD/YYYY"));
                } else {
                    update.push(item[key]);
                }
            });
    
            return update;
        });
        const updates = [
            filteredKeyNames,
            ...items
        ]
        writeXlsxFile(updates)
        setLoading(false);
    }

    function DiligentSearchToolbar() {
        return (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 1.5, py: 1.5, px: 1 }}>
                <Typography variant="subtitle1" fontWeight={600} sx={{ color: '#334155', mr: 'auto', pl: 1 }}> {tabValue === DiligentTabs.OpenDiligent ? 'Open Diligent Searches' : 'Completed Diligent Searches'}</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Button
                        variant="contained"
                        size="medium"
                        onClick={() => onExportXlsx(ReportModuleCL.getOutstandingFilingsReport_Respdata || [])}
                        startIcon={<FileDownload />}
                        sx={{
                            textTransform: 'none',
                            fontWeight: 600,
                            backgroundColor: '#2099d2',
                            '&:hover': { backgroundColor: '#176990' },
                            px: 2,
                            py: 0.5
                        }}
                    >
                        Export
                    </Button>
                </Box>
            </Box>
        );
    }

    return (
        <React.Fragment>
            <Box
                sx={{
                    height: 'calc(100vh - 250px)',
                    width: '100%',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    boxShadow: '0 4px 24px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.06)',
                    border: '1px solid #e2e8f0',
                    backgroundColor: '#ffffff',
                    position: 'relative',
                }}
            >
                {loading && (
                    <Box
                        position="absolute"
                        top={0}
                        left={0}
                        right={0}
                        bottom={0}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        sx={{
                            backgroundColor: "rgba(250, 251, 252, 0.85)",
                            zIndex: 10,
                            border: "1px solid #e2e8f0",
                            borderRadius: 1,
                        }}
                    >
                        <Box sx={{ width: "100%", maxWidth: 320 }}>
                            <LinearProgress color="info" sx={{ backgroundColor: "#e2e8f0", "& .MuiLinearProgress-bar": { backgroundColor: "#132D3D" } }} />
                            <Box sx={{ mt: 1.5, textAlign: "center" }}>
                                <span style={{ fontSize: "14px", fontWeight: 600, color: "#475569" }}>Loading...</span>
                            </Box>
                        </Box>
                    </Box>
                )}
                <DataGridPro
                    getRowId={(r) => r.rowNum}
                    rows={ReportModuleCL.getOutstandingFilingsReport_Respdata}
                    columns={updatedColumns}
                    pageSize={_pageSize}
                    pagination
                    checkboxSelection={tabValue === DiligentTabs.OpenDiligent}
                    selectionModel={selectedRows?.map((item) => item.rowNum).filter((rowNum): rowNum is Exclude<typeof rowNum, undefined> => rowNum !== undefined) || []}
                    onSelectionModelChange={(newRowSelectionModel) => {
                        onRowsSelectionHandler(newRowSelectionModel)
                    }}
                    rowCount={ReportModuleCL.totalCount}
                    rowsPerPageOptions={getRowsPerPageOptions(ReportModuleCL?.totalCount, _pageSize)}
                    paginationMode="server"
                    onPageChange={(newPage) => handleNextPreviousPage(newPage + 1)}
                    onPageSizeChange={(newPageSize) => handlePageSize(newPageSize)}
                    style={{ textAlign: "center" }}
                    sortingMode="server"
                    onSortModelChange={handleSortModelChange}
                    filterMode="server"
                    onFilterModelChange={handleFilterChange}
                    sortModel={sortRef.current}
                    sortingOrder={['desc', 'asc']}
                    components={{
                        Toolbar: DiligentSearchToolbar,
                    }}
                    sx={{
                        fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                        border: 'none',
                        fontSize: '14px',
                        color: '#475569',
                        backgroundColor: '#ffffff',
                        "& .MuiDataGridPro-columnHeaderTitle": {
                            whiteSpace: 'normal',
                            lineHeight: 1.35,
                            fontWeight: 600,
                            fontSize: '12px',
                            letterSpacing: '0.05em',
                            textTransform: 'uppercase',
                            color: '#64748b',
                        },
                        "& .MuiDataGrid-columnHeaders": {
                            backgroundColor: '#f8fafc',
                            borderBottom: '2px solid #e2e8f0',
                            minHeight: '52px !important',
                            maxHeight: '52px !important',
                        },
                        "& .MuiDataGrid-columnHeader": {
                            "&:focus, &:focus-within": { outline: 'none' },
                        },
                        "& .MuiDataGrid-row": {
                            transition: 'background-color 0.15s ease',
                            "&:nth-of-type(even)": {
                                backgroundColor: '#fafbfc',
                            },
                            "&:hover": {
                                backgroundColor: '#f1f5f9 !important',
                            },
                            "&.Mui-selected": {
                                backgroundColor: '#ebf5fa !important',
                                "&:hover": {
                                    backgroundColor: '#dbeef7 !important',
                                },
                            },
                        },
                        "& .MuiDataGrid-cell": {
                            borderBottom: '1px solid #f1f5f9',
                            fontSize: '14px',
                            color: '#334155',
                            "&:focus": { outline: 'none' },
                        },
                        "& .MuiDataGrid-virtualScroller": {
                            border: 'none',
                        },
                        "& .MuiDataGrid-main": {
                            border: 'none',
                        },
                        "& .MuiDataGrid-footerContainer": {
                            borderTop: '1px solid #e2e8f0',
                            backgroundColor: '#f8fafc',
                            minHeight: 56,
                        },
                        "& .MuiTablePagination-root": {
                            color: '#64748b',
                            fontSize: '13px',
                        },
                        "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
                            marginBottom: 0,
                        },
                        "& .MuiTablePagination-select": {
                            fontSize: '13px',
                            borderRadius: '6px',
                            border: '1px solid #e2e8f0',
                        },
                        "& .MuiIconButton-root": {
                            color: '#64748b',
                            "&:hover": {
                                backgroundColor: '#f1f5f9',
                                color: '#475569',
                            },
                        },
                        "& .MuiCheckbox-root": {
                            color: '#94a3b8',
                            "&.Mui-checked": {
                                color: '#2099d2',
                            },
                        },
                    }}
                    experimentalFeatures={{ newEditingApi: true }}
                    columnVisibilityModel={{
                        paymentDate: user?.userRoles.split(",").includes("Super Admin")
                            ? true
                            : false,
                        paymentAmount: user?.userRoles.split(",").includes("Super Admin")
                            ? true
                            : false,
                        lineOfBusiness: user?.userRoles.split(",").includes("Super Admin")
                            ? true
                            : false,
                    }}
                />
                <AddEditDiligentSearh
                    handleClose={handleClose}
                    fetchDataMain={fetchDataMain}
                    Open={Open}
                    StateRuleMatrixCL={Formdata}
                    handleSubmit={handleSubmit}
                    initValues={initialLBData}
                    tabValue={tabValue}
                    completedPage={completedPage}
                />
                <AddEditDocument open={openDoc} handleClose={handleClose} customerPolicyId={ID}></AddEditDocument>
                <ShowAllDocument open={showDoc} DiligentDocument={DiligentDocument} handleDocClose={handleDocClose} customerPolicyId={ID}></ShowAllDocument>
            </Box>

        </React.Fragment>
    );
};

export function GenericStyledDropZone(props: any) {
    const {
        getRootProps,
        getInputProps,
        acceptedFiles,
        isFocused,
        isDragAccept,
        isDragReject,

    } = useDropzone({
        maxFiles: 10,
        // accept: { 'application/pdf': ['.pdf'], 'application/word': ['.word'] },
        accept: { 'application/pdf': ['.pdf'], 'image/*': [], 'application/msg': ['.msg'], 'application/word': ['.word'] },
        onDrop:
            (files) => {
                // debugger
                formData.delete("document");

                files.map((pp, key) =>
                    formData.append("document" + key, files[key])
                )
            }
    });

    const isDragOver = isFocused || isDragAccept;
    const isReject = isDragReject;
    const files = acceptedFiles.map((file) => (
        <Box key={file.name + file.size} component="li" sx={{ py: 0.5, fontSize: '14px', color: '#162E3C' }}>
            {file.name.length > 60 ? file.name.substring(0, 60) + '...' : file.name}
            {' '}
            <Typography component="span" variant="caption" color="text.secondary">
                ({(file.size / 1024).toFixed(1)} KB)
            </Typography>
        </Box>
    ));

    return (
        <Box>
            <Paper
                {...getRootProps({ style: { outline: 'none' } })}
                sx={{
                    border: isReject ? '2px dashed #ff1744' : isDragOver ? '2px dashed #02A4E3' : '1px dashed #ccc',
                    borderRadius: 2,
                    p: 4,
                    textAlign: 'center',
                    backgroundColor: isDragOver ? '#f0f8ff' : '#fafafa',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    mb: 2,
                    minHeight: 200,
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    boxShadow: 'none',
                }}
            >
                <input {...getInputProps()} name="diligentdocument" multiple />
                <CloudUpload sx={{ fontSize: 48, color: '#02A4E3', mb: 2 }} />
                <Typography variant="h6" sx={{ color: '#666', mb: 1 }}>
                    Select File or Drag and Drop
                </Typography>
                <Typography variant="body2" sx={{ color: '#999' }}>
                    Click to browse files or drag and drop multiple files here
                </Typography>
            </Paper>
            {acceptedFiles.length > 0 && (
                <Box sx={{ mt: 2, mb: 0 }}>
                    <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 600, color: 'text.secondary' }}>
                        Attached documents ({acceptedFiles.length})
                    </Typography>
                    <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
                        {files}
                    </Box>
                </Box>
            )}
        </Box>
    );
}


interface props {
    open: boolean
    handleClose: () => void,
    customerPolicyId: any
}

const AddEditDocument: React.FC<props> = ({ open, handleClose, customerPolicyId }) => {
    const initialValues: {} = {};
    const [loading, setloading] = useState(false);
    const { user } = useAuth();
    const token = user?.token;

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="lg"
            fullWidth
            PaperProps={{
                sx: {
                    width: '90%',
                    maxWidth: 900,
                    minHeight: '50vh',
                    maxHeight: '90vh',
                    borderRadius: 2,
                    boxShadow: '0 24px 48px rgba(0,0,0,0.12)',
                },
            }}
            sx={{ '& .MuiDialog-paper': { overflow: 'hidden' } }}
        >
            {loading && <LinearProgress sx={{ flexShrink: 0 }} />}
            <DialogTitle
                sx={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 1,
                    py: 2,
                    px: 3,
                    background: 'linear-gradient(135deg, #0d4a63 0%, #15607a 100%)',
                    color: '#fff',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <DescriptionOutlinedIcon sx={{ fontSize: 28, opacity: 0.95 }} />
                    <Typography component="span" variant="h6" sx={{ fontWeight: 600, letterSpacing: '0.02em' }}>
                        Upload Document
                    </Typography>
                </Box>
                <IconButton
                    onClick={handleClose}
                    sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(255,255,255,0.12)' } }}
                    aria-label="Close dialog"
                >
                    <CloseOutlinedIcon />
                </IconButton>
            </DialogTitle>
            <Formik
                initialValues={initialValues}
                validateOnChange={true}
                onSubmit={(data, { setSubmitting }) => {
                    let count = 0;
                    formData.forEach(() => { count = count + 1; });
                    if (count < 1) {
                        alert("select a document");
                        setSubmitting(false);
                        return;
                    }
                    formData.append('CustomerPolicyId', customerPolicyId);
                    formData.append("data", JSON.stringify(data));
                    setloading(true);
                    apiClient(`/DiligentSearch/UploadDocument/`, {
                        method: 'POST',
                        headers: new Headers({ 'Authorization': `Bearer ${token}` }),
                        body: formData,
                    })
                        .then((res) => {
                            if (!res) return;
                            Swal.fire('Success', res.data, 'info');
                        }).finally(() => {
                            setSubmitting(false);
                            formData = new FormData();
                            setloading(false);
                            handleClose();
                        });
                }}
            >
                {({ isSubmitting }) => (
                    <Form className="main-form">
                        <DialogContent sx={{ width: '100%', minHeight: '50vh', overflow: 'auto', px: { xs: 2, sm: 3 }, py: 3 }}>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Typography variant="overline" sx={{ color: 'text.secondary', fontWeight: 600, letterSpacing: '0.08em', display: 'block', mb: 1 }}>
                                        Attachments
                                    </Typography>
                                    <FormHelperText className="formtexthelper-heading" sx={{ mb: 0.5 }}>
                                        Select file(s) or drag and drop
                                    </FormHelperText>
                                    <GenericStyledDropZone Key={1} />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions
                            sx={{
                                px: 3,
                                py: 2,
                                gap: 1.5,
                                borderTop: 1,
                                borderColor: 'divider',
                                backgroundColor: 'grey.50',
                                flexWrap: 'wrap',
                            }}
                        >
                            <Button
                                variant="outlined"
                                size="medium"
                                onClick={handleClose}
                                startIcon={<CloseOutlinedIcon />}
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    borderColor: '#e2e8f0',
                                    color: '#475569',
                                    '&:hover': {
                                        borderColor: '#2099d2',
                                        backgroundColor: '#2099d214',
                                        color: '#2099d2',
                                    },
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                size="medium"
                                type="submit"
                                disabled={isSubmitting}
                                startIcon={<FileUploadOutlinedIcon />}
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    backgroundColor: '#2099d2',
                                    '&:hover': { backgroundColor: '#176990' },
                                    px: 2.5,
                                }}
                            >
                                Upload
                            </Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
}

interface propsDoc {
    open: boolean
    handleDocClose: () => void,
    customerPolicyId: any,
    DiligentDocument: DiligentSearchDocument[] | undefined
}
const ShowAllDocument: React.FC<propsDoc> = ({ open, handleDocClose, customerPolicyId, DiligentDocument }) => {
    return (
        <Dialog
            open={open}
            onClose={handleDocClose}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: {
                    width: '90%',
                    maxWidth: 640,
                    maxHeight: '85vh',
                    borderRadius: 2,
                    boxShadow: '0 24px 48px rgba(0,0,0,0.12)',
                },
            }}
            sx={{ '& .MuiDialog-paper': { overflow: 'hidden' } }}
        >
            <DialogTitle
                sx={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 1,
                    py: 2,
                    px: 3,
                    background: 'linear-gradient(135deg, #0d4a63 0%, #15607a 100%)',
                    color: '#fff',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <DescriptionOutlinedIcon sx={{ fontSize: 28, opacity: 0.95 }} />
                    <Typography component="span" variant="h6" sx={{ fontWeight: 600, letterSpacing: '0.02em' }}>
                        All Documents
                    </Typography>
                </Box>
                <IconButton
                    onClick={handleDocClose}
                    sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(255,255,255,0.12)' } }}
                    aria-label="Close dialog"
                >
                    <CloseOutlinedIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ px: { xs: 2, sm: 3 }, py: 3, overflow: 'auto' }}>
                {DiligentDocument && DiligentDocument.length > 0 ? (
                    <Box component="ul" sx={{ m: 0, pl: 2.5, listStyle: 'none' }}>
                        {DiligentDocument.map((value, key) => (
                            <Box component="li" key={key} sx={{ py: 1, borderBottom: key < DiligentDocument.length - 1 ? 1 : 0, borderColor: 'divider' }}>
                                <Link
                                    href={value.blob_Address}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: 0.5,
                                        color: '#2099d2',
                                        fontWeight: 500,
                                        textDecoration: 'none',
                                        maxWidth: '100%',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        '&:hover': { textDecoration: 'underline' },
                                    }}
                                >
                                    {value.documentName.length > 99 ? value.documentName.substring(0, 99) + '...' : value.documentName}
                                    <FileDownload sx={{ fontSize: 18, flexShrink: 0 }} />
                                </Link>
                            </Box>
                        ))}
                    </Box>
                ) : (
                    <Typography color="text.secondary" sx={{ py: 2 }}>
                        No supportive document found for this transaction.
                    </Typography>
                )}
            </DialogContent>
            <DialogActions
                sx={{
                    px: 3,
                    py: 2,
                    borderTop: 1,
                    borderColor: 'divider',
                    backgroundColor: 'grey.50',
                }}
            >
                <Button
                    variant="outlined"
                    size="medium"
                    onClick={handleDocClose}
                    startIcon={<CloseOutlinedIcon />}
                    sx={{
                        textTransform: 'none',
                        fontWeight: 600,
                        borderColor: '#e2e8f0',
                        color: '#475569',
                        '&:hover': { borderColor: '#2099d2', backgroundColor: '#2099d214', color: '#2099d2' },
                    }}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}



